module.exports = __webpack_public_path__ + "media/images/vp/icon.ok.red-818c2a3f14b2bbcce8247f0cbed4a60a.png";